import gql from 'graphql-tag';

export const GET_LIST_OF_PACCAR_MANUFACTURERS = gql`
  query GetListOfPacCarManufacturers {
    paccarManufactureres {
      name
      paccarCode
      type
      assetType
      classType
      cabType
      assetType
    }
  }
`;
